const scrollLockMethod = element => {
  const scrollLock = element ? 'disableBodyScroll' : 'enableBodyScroll';
  bodyScrollLock[scrollLock](document.body);
};

export default scrollLockMethod;
